import { Text } from '@change/ds-core-ui';

import { CheckBox } from '../CheckBox';

import type { SavedPaymentMethodContent } from './types';
import { getContent } from './utils/getContent';

type Props = {
	paymentMethod: SavedPaymentMethodContent;
	index: number;
};

export const SavedPaymentMethodSlot: React.FC<Props> = ({ paymentMethod, index }) => {
	const content = getContent({ paymentMethod, index });
	return (
		<div className="flex min-h-17 flex-row items-center justify-between p-3">
			<div className="flex flex-row items-center gap-5">
				{content.icon}
				<div className="flex flex-col">
					<Text className="text-typography-strong">{content.label}</Text>
					{content.details && (
						<Text className="text-typography-weak" size="small">
							{content.details}
						</Text>
					)}
				</div>
			</div>
			<CheckBox />
		</div>
	);
};
